module.exports = __webpack_public_path__ + "img/logo2.e6a25cbc.png";